import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/app/App";

export function indexLoaded() {
  const container = document.getElementById("app")!;
  if (!container) {
    throw new Error("No container found");
  }
  const root = createRoot(container);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
